
import { Button, GridLegacy as Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete } from '@mui/material';
import dayjs from '../../utils/dayjs-setup';
import { useState,  } from "react";
import { AxiosInstance } from "../../utils/constants";
import * as yup from "yup";

import { DatePicker } from "@mui/x-date-pickers";


  
 export  const ModalDialogConfig = ({
    openedModal,
    setOpenedModal,
    onSaveModalConfirm,
    currentConfig,
    onChangeForm
  })=>{
    console.log({currentConfig});
  
    const [centrosOp,setCentrosOp] = useState([]);
    const [bodegasFilter,setBodegasFilter] = useState([]);


  
 const loadCentrosOp = async(search)=>{
        const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
        setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
      }
const searchCpAsociado = async (event, newInputValue) => {
      
        await loadCentrosOp(newInputValue.toLowerCase());
       
}
const loadBodegas = async(search)=>{
      
        const  {data:{value}} = await AxiosInstance.post("cotzaciones/obtener-bodegas-filter",{
            centrop_ope_id:currentConfig.centro_operacion.value,
            search
        });
       
        setBodegasFilter(value);
      }
      const searchBodega = async (event, newInputValue) => {
        if (newInputValue && currentConfig.centro_operacion){
          await loadBodegas(newInputValue.toLowerCase());
        }
       
       
       
}


  
  
    return <Dialog
    open={openedModal}
  >
    <DialogTitle>Configurar Ordenes de compra</DialogTitle>
    <DialogContent>
        
        <Grid container spacing={2} sx={{padding:'10px'}}  >
        <Grid item sx={12} md={12} >
            
            <Autocomplete 
                {
                  ...{
                  
                    typeInput:"autoComplete",
                    onChange:(evt,value)=>onChangeForm("centro_operacion",value),
                    value:currentConfig.centro_operacion,
                    name: 'centro_operacion',
                    fullWidth: true,
                    isLoading: false,
                    multiple:false,
                    onInputChange: searchCpAsociado,
                    options: centrosOp || [],
                    noOptionsText: "Lista vacia",
                    getOptionLabel: (option) => option.label,
                    isOptionEqualToValue: (option, value) => option.value === value.value,
                    filterOptions: (x) => x,
                    renderInput:(props)=><TextField label='Centro de operacion' {...props} />
                  }
                }
            />

          </Grid>
          <Grid item sx={12} md={12} >

            <Autocomplete 
                {
                  ...{
                    typeInput:"autoComplete",
                    onChange:(evt,value)=>onChangeForm("bodega",value),
                    value:currentConfig.bodega,
                    name: 'bodega',
                    fullWidth: true,
                    isLoading: false,
                    multiple:false,
                    onInputChange: searchBodega,
                    options: bodegasFilter || [],
                    noOptionsText: "Lista vacia",
                    getOptionLabel: (option) => option.label,
                    isOptionEqualToValue: (option, value) => option.value === value.value,
                    filterOptions: (x) => x,
                    renderInput:(props)=><TextField label='Bodega' {...props} />
                  }
                }
            />

          </Grid>
          <Grid item sx={12} md={12} >
         
          <DatePicker 
              minDate={dayjs()}
              value={dayjs(currentConfig.fecha_entrega)} 
              onChange={value=>{
               
                onChangeForm("fecha_entrega",value)
              }} 
              slotProps={{ textField: { fullWidth: true } }}
          label="Fecha de entrega" />
          </Grid>
        </Grid>
      <DialogActions>
        <Button type="button" onClick={e=>setOpenedModal(false)} variant="contained" color="secondary"  >Cancelar</Button>
        <Button onClick={e=>onSaveModalConfirm(currentConfig)} variant="contained" color="primary"  >Guardar cambios</Button>
      </DialogActions>
    </DialogContent>
  
  </Dialog>
  
    
  }